import actions from './actions';
import getters from './getters';

export default {
  actions,
  getters,
};
